module.exports = __webpack_public_path__ + "img/c3.4873a489.png";